<template>
  <div id="profile-details" class="content-pane">
    <form :class="{ loading }" @submit.prevent="saveProfile">
      <personal-fields
        :data.sync="profile"
        :errors="errors"
        :form_options="form_options"
        ref="focus"
      ></personal-fields>
      <company-fields
        :data.sync="profile"
        :errors="errors"
        :form_options="form_options"
        @selected="gst_not_appplicable_handler"
        @deselected="gst_appplicable_handler"
      ></company-fields>
      <billing-address-fields
        :data.sync="profile"
        :errors="errors"
        :form_options="form_options"
      ></billing-address-fields>
      <!--      <biography-field-->
      <!--          :data.sync="profile"-->
      <!--          :errors="errors"-->
      <!--      ></biography-field>-->
      <div class="form-section columned two-column">
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.password }"
        >
          <label for="profile-change-password">Change Password</label>
          <input
            id="profile-change-password"
            type="password"
            name="change_password"
            v-model="profile.password"
          />
          <input-error v-if="errors.password">
            {{ errors.password[0] }}
          </input-error>
        </div>
        <div class="form-group vanilla">
          <label for="profile-confirm-password">Confirm Password</label>
          <input
            id="profile-confirm-password"
            type="password"
            name="password_confirmation"
            v-model="profile.password_confirmation"
          />
        </div>
        <div class="form-group vanilla submit">
          <loader-button
            type="submit"
            :loading="loading"
            label="Save Profile"
          ></loader-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import merge from "lodash/merge";
import cloneDeep from "lodash/cloneDeep";
import PersonalFields from "../shared-fields/Personal";
import { fields as personalData } from "../shared-fields/Personal";
import CompanyFields from "../shared-fields/Company";
import { fields as companyData } from "../shared-fields/Company";
import BillingAddressFields from "../shared-fields/BillingAddress";
import { fields as billingAddressData } from "../shared-fields/BillingAddress";

export default {
  mounted() {
    this.$eventBus.$on("accountNavigate", (mutation) => {
      if (
        (mutation.payload.page === "account-details" &&
          mutation.payload.subpage === "index") ||
        (mutation.type === "account/navigateSubpage" &&
          mutation.payload === "index")
      ) {
        this.assignProfileDataFromStore();
      }
    });
    this.assignProfileDataFromStore();
    this.form_options = this.$root.$refs.accountPanel.formOptions;
  },
  components: {
    PersonalFields,
    CompanyFields,
    BillingAddressFields,
  },
  data() {
    return {
      profile: merge(personalData, companyData, billingAddressData, {
        notifications: "",
        password: "",
        password_confirmation: "",
      }),
      form_options: {
        companies: [],
        company_types: [],
        gender: [],
        member_types: [],
        notifications: {},
        states: [],
      },
      loading: false,
      errors: [],
    };
  },
  methods: {
    assignProfileDataFromStore() {
      this.$nextTick(() => {
        this.profile = cloneDeep(this.account);
      });
    },

    gst_not_appplicable_handler() {
      this.profile.gst = 0;
    },

    gst_appplicable_handler() {
      this.profile.gst = 1;
    },
    saveProfile() {
      if (this.profile.gst == 0) {
        this.profile.abn = null;
        this.profile.business_name = null;
      }

      if (this.profile.company_type == null && this.account.type == "hirer") {
        var err = { company_type: ["The company type field is required."] };
        this.errors = { ...this.errors, ...err };
        this.$toasted.show("The company type field is required.", {
          type: "error",
        });
        return;
      }
      if (this.account.type == "hirer") {
        if (!this.validateABN()) {
          var err = { abn: ["Please Enter Valid ABN Number"] };
          this.errors = { ...this.errors, ...err };
          this.$toasted.show("Invalid ABN Number.", {
            type: "error",
          });
          return;
        }
      }
      if (!this.loading) {
        this.loading = true;
        this.errors = [];

        axios
          .put("/api/account/profile", this.profile)
          .then(() => {
            //this.$store.commit('user/updateAccount', response.data)
            this.$store.dispatch("user/refreshUser");
            this.$toasted.show("Your profile has been updated.", {
              type: "success",
            });
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.$toasted.show(
                "Your profile could not be updated, please review errors and try again.",
                {
                  type: "error",
                }
              );
              return (this.errors = error.response.data.errors);
            }
            this.$toasted.show(
              "Oops! We couldn't update your profile, please refresh the page and try again.",
              {
                type: "error",
              }
            );
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
    validateABN() {
      if (this.profile.abn.length != 11 || isNaN(parseInt(this.profile.abn)))
        return false;

      let weighting = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
      let firstDigitProcessed = parseInt(this.profile.abn.charAt(0)) - 1;
      let weighted = firstDigitProcessed * weighting[0];

      for (var i = 1; i < this.profile.abn.length; i++) {
        weighted += parseInt(this.profile.abn.charAt(i)) * weighting[i];
      }

      return weighted % 89 == 0;
    },
  },
  computed: {
    ...mapGetters({
      account: "user/account",
    }),
  },
};
</script>
